module.exports = __webpack_public_path__ + "static/media/sup_tropical_1600.b3468409.webp";